import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_33v847t70q: FaireBrandEntity = {
  token: "b_33v847t70q",
  type: "brand",
  name: "Sol Food",
  avatarUrl:
    "https://cdn.faire.com/fastly/7ef6d0d1fa59b3d07a136b455ed9c2b55f3a1ac61d348a263bf2466e3ef74bcc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/59da66e8437b975408dfa59b698abb2ab64870b0bd8a7163d980fa5c2ec9a54f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7ef6d0d1fa59b3d07a136b455ed9c2b55f3a1ac61d348a263bf2466e3ef74bcc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/59da66e8437b975408dfa59b698abb2ab64870b0bd8a7163d980fa5c2ec9a54f.png",
  location: "San Rafael, CA, USA",
  minimumOrderDollars: 40,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "Sol Food Puerto Rican Cuisine started at the Farmers’ Market in 2003, located in downtown San Rafael, CA, now with 3 location in Marin County.  We bottle our famous Pique (hot pepper sauce) and Lemon Salad Dressing which are a delicious addition to any meal.  Both items include fresh, high quality ingredients.  Splash some Pique on your rice & beans, sandwiches, fresh oysters, or any favorite meal. The Lemon Dressing is perfect on your favorite salad, or use as a marinade for grilled or baked veggies and meats.  Que los disfruta!\n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:23.144Z",
    importedBy: "entity-db-cli",
  },
};
